import UserTokenProfile from "@/domain/entities/dashboard/UserTokenProfile";
import { useIaTokenStatus } from "@cs_teamwaydev/mailvista-sdk_react";
import { isValid, parseISO } from "date-fns";
import { useMemo } from "react";
import useGetUserProfile from "./useGetUserProfile";

const renewalDateFromNextQuotaIso = (
    iso: string | null | undefined,
): Date | undefined => {
    if (!iso) return undefined;
    const parsed = parseISO(iso);
    return isValid(parsed) ? parsed : undefined;
};

const useGetTokenProfile = () => {
    const { data: tokenStatus } = useIaTokenStatus();
    const { data: user } = useGetUserProfile();

    const data = useMemo(() => {
        if (!tokenStatus) return null;

        return new UserTokenProfile({
            used: tokenStatus.used,
            total: tokenStatus.total,
            renewalDate: renewalDateFromNextQuotaIso(
                user?.nextQuotaRenewalDate,
            ),
        });
    }, [tokenStatus, user?.nextQuotaRenewalDate]);

    return { data };
};

export default useGetTokenProfile;
